export const theme = {
  colors: {
    primary: '#000',
    secondary: '#fff',
    highlight: 'rgba(0, 0, 0, 0.4)',
  },
};
